import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export function ActionButton({
  use = 'link',
  action,
  actionType,
  'data-test-id': dataTestId = `${actionType}-subscription-button`,
  label
}) {
  const {
    validation,
    open
  } = action;
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !validation,
    title: validation,
    "data-test-id": `${dataTestId}-tooltip`,
    placement: "left",
    children: /*#__PURE__*/_jsx(Button, {
      onClick: open,
      use: use,
      disabled: !!validation,
      "data-test-id": dataTestId,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: label !== null && label !== void 0 ? label : `subscriptions.Actions.${actionType}.label`
      })
    })
  });
}